import { Component, EventEmitter, Output } from '@angular/core';
import { MobileAppSubpage } from '../mobile-store/mobile.data';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { mobileHomePageMenuReselector } from '../mobile-store/mobile.app.reselector';
import { CommonModule } from '@angular/common';
import { AppIconComponent } from 'src/app/modules/app/app-icon.component';
import { mobileAppFeature } from '../mobile-store/mobile.app.era';

@Component({
    selector: 'mobile-app-home-menu',
    template: `
<app-icon *ngFor="let sub of subPages" 
  [icon]="pageIcons[sub]" 
  [title]="tabNames[mobileAppSubpageToTabId[sub]]" [active]="'home' === sub" (click)="clickSubpage.emit(sub)"></app-icon>
`,
    styleUrls: ["./mobile-app-top-nav.scss"],
    standalone: true,
    imports: [CommonModule, AppIconComponent]
})
export class MobileAppHomeMenuComponent extends MobileAppWrapper<MobileAppHomeMenuComponent>  {
  subPages: MobileAppSubpage[] = []
  tabNames:{ [tId: string]: string } = getDefaultProgramTabNames()
  @Output() clickSubpage: EventEmitter<MobileAppSubpage> = new EventEmitter()

  constructor() {
    super()
    this.subProp(this.store.select(mobileAppFeature.selectTabNames), 'tabNames')
    this.selectProp(mobileHomePageMenuReselector, null, 'subPages')

  }
}